// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-invoice-status-list-item .fi-invoice-status-container {
  padding-top: 8px;
  padding-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./Source/app/customer-billing/customer-billing-invoice/invoice-status-list-item/invoice-status-list-item.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,mBAAA;AAAR","sourcesContent":[".fi-invoice-status-list-item {\r\n    .fi-invoice-status-container {\r\n        padding-top: 8px;\r\n        padding-bottom: 8px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
